// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".config-tips[data-v-141c170b] {\n  margin-top: 8px;\n  color: #666;\n  font-size: 12px;\n}\n.config-tips .anticon[data-v-141c170b] {\n  margin-right: 4px;\n  color: #1890ff;\n}\n.ant-form-model-item[data-v-141c170b] {\n  margin-bottom: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
